export const HOLIDAY_CONSTANTS = {
    MODULE_NAME: 'Holidays',
    DATE_LABEL: 'Date*',
    DATE: 'Date',
    HOLIDAY_LABEL:'Holiday',
    NO_DATA_INFO: "No Holidays found.",
    NEW_HOLIDAY_ADDED_MSG: "Holiday added.",
    DELETE_MSG: "Are you sure you want to delete the holiday?",
    DESCRIPTION_LABEL: 'Description*',
}